import { gql } from '@apollo/client';

export const SEND_USER_RECOVERY_MAIL_QUERY = gql`
  query sendUserRecoveryMail($emailId: String!, $source: String!) {
    sendUserRecoveryMail(emailId: $emailId, source: $source)
  }
`;

export const MEET_SIGN_IN_QUERY = gql`
  query MeetSignIn($input: signInInput!) {
    meetSignIn(input: $input) {
      ... on signInSuccessOutput {
        userDetails {
          uFirstName
          uId
          uRole
        }
        AccessToken
        IdToken
        RefreshToken
        __typename
      }
      ... on multiUserOutput {
        users {
          uUserName
          uRole
          uAvatarUrl
        }
        __typename
      }
    }
  }
`;

export type MeetSignInResponse = {
  meetSignIn?: {
    __typename?: 'signInSuccessOutput' | 'multiUserOutput';
    AccessToken?: string;
    IdToken?: string;
    RefreshToken?: string;
    userDetails?: {
      uFirstName?: string;
      uId?: string;
      uRole?: string;
    };
  };
};

export const GET_USER_QUERY = gql`
  query GetUser {
    getUser {
      uAvatarUrl
      uEmailId
      uFirstName
      uRole
      uSurName
      uUserName
      uId
      orgDetails {
        moId
        moName
        moLogo
      }
    }
  }
`;

export const GET_ACCESS_TOKEN_QUERY = gql`
  query GetAccessToken($refreshToken: String!) {
    getaccessToken(refreshToken: $refreshToken) {
      AccessToken
      ExpiresIn
      RefreshToken
    }
  }
`;

export type GetAccessTokenResponse = {
  getaccessToken?: {
    AccessToken: string;
    ExpiresIn: number;
    RefreshToken: string;
  };
};
